"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageActionType = exports.AuthTransitionType = exports.UserUpdateType = exports.EventName = void 0;
/**
 * Namespaced event names for the Aurora application.
 */
var EventName;
(function (EventName) {
    EventName["AUTH_CHANGE"] = "kh-aurora:authChange";
    EventName["CLOSE_ACCOUNT"] = "kh-aurora:closeAccount";
    EventName["MESSAGE_CREATED"] = "kh-aurora:messageCreated";
    EventName["MESSAGE_EDITED"] = "kh-aurora:messageEdited";
    EventName["MESSAGE_DELETED"] = "kh-aurora:messageDeleted";
    EventName["MESSAGE_MOVED"] = "kh-aurora:messageMoved";
    EventName["ROUTE_CHANGE"] = "kh-aurora:routeChange";
    EventName["ROUTE_CHANGED"] = "kh-aurora:routeChanged";
    EventName["USER_REGISTERED"] = "kh-aurora:userRegistered";
    EventName["USER_UPDATED"] = "kh-aurora:userUpdated";
})(EventName || (exports.EventName = EventName = {}));
/**
 * Types of updates that can be made to a user.
 */
var UserUpdateType;
(function (UserUpdateType) {
    UserUpdateType["PASSWORD_CHANGE"] = "passwordChange";
    UserUpdateType["EMAIL_CHANGE"] = "emailChange";
    UserUpdateType["EMAIL_VERIFIED"] = "emailVerified";
    UserUpdateType["USERNAME_CHANGE"] = "usernameChange";
    UserUpdateType["PERSONAL_SETTINGS_CHANGE"] = "personalSettingsChange";
})(UserUpdateType || (exports.UserUpdateType = UserUpdateType = {}));
/**
 * Types of auth-related transitions that can occur.
 */
var AuthTransitionType;
(function (AuthTransitionType) {
    AuthTransitionType["CLOSE_ACCOUNT"] = "closeAccount";
    AuthTransitionType["FORGOT_PASSWORD"] = "forgotPassword";
    AuthTransitionType["LOCK_OUT"] = "lockOut";
    AuthTransitionType["LOGIN"] = "login";
    AuthTransitionType["LOGOUT"] = "logout";
    AuthTransitionType["REGISTRATION"] = "registration";
})(AuthTransitionType || (exports.AuthTransitionType = AuthTransitionType = {}));
/**
 * Types of actions that can be taken on a message.
 */
var MessageActionType;
(function (MessageActionType) {
    MessageActionType["CREATE"] = "create";
    MessageActionType["DELETE"] = "delete";
    MessageActionType["EDIT"] = "edit";
    MessageActionType["MOVE"] = "move";
})(MessageActionType || (exports.MessageActionType = MessageActionType = {}));
//# sourceMappingURL=enums.js.map